export function treeReduce(nodes, fn, initialValue, childName = 'children', parentNode) {
    return nodes.reduce((previousValue, node, index) => {
        const newValue = fn(previousValue, node, index, parentNode);
        const children = node[childName];
        if (children && children.length) {
            return treeReduce(children, fn, newValue, childName, node);
        }
        return newValue;
    }, initialValue);
}
export function treeForEach(nodes, fn, childName = 'children', parentNode) {
    nodes.forEach((node, index) => {
        fn(node, index, parentNode);
        const children = node[childName];
        if (children && children.length) {
            treeForEach(children, fn, childName, node);
        }
    });
}
